import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {AuthorizeService, IUser} from '../authorize.service';
import {Observable, Subscription} from 'rxjs';
import {GlobalContextService} from "../../app/globalcontext.service";
import {map} from "rxjs/operators";


@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginMenuComponent implements OnInit, OnDestroy {
  public isAuthenticated: Observable<boolean>;
  public userName: Observable<string>;
  public user: Observable<IUser>;
  public clientName: string;

  interval: any;

  _subscription: Subscription;
  
  constructor(private authorizeService: AuthorizeService,
              private globalContextService: GlobalContextService,
              private ref: ChangeDetectorRef) {  }

  ngOnInit() {
    this.isAuthenticated = this.authorizeService.isAuthenticated();
    this.user = this.authorizeService.getUser();
    this.userName = this.authorizeService.getUser().pipe(map(u => u && u.name));
    this.clientName  = this.globalContextService.GetClientName();

    //this.clientName = this.globalContextService.name;
    this._subscription = this.globalContextService.nameChange.subscribe((value) => {
      this.clientName = value;
    });
    this.interval =  setInterval(() => {
      this.ref.detectChanges();
    }, 1000);
  }

  ngOnDestroy() {
    if (this._subscription != undefined)   this._subscription.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.ref.detach();
  }
}
